import {ROUTES} from '@/config/routesConstants';

export type BrandChangeRedirect = {to: string} | {sendToEmberIframe: string};

/**
 * When changing brand, redirect to the base route for the new brand (or notify
 * Ember for iframe-hosted pages).
 */
const BRAND_CHANGE_REDIRECTIONS: {
  matcher: string;
  redirect: BrandChangeRedirect;
}[] = [
  {matcher: ROUTES.CAMPAIGNS_V2, redirect: {to: ROUTES.CAMPAIGNS_V2}},
  {matcher: ROUTES.CAMPAIGNS, redirect: {to: ROUTES.CAMPAIGNS}},
  {matcher: ROUTES.SEARCH, redirect: {to: ROUTES.SEARCH}},
  {matcher: ROUTES.MY_CREATORS, redirect: {to: ROUTES.MY_CREATORS}},
  {matcher: ROUTES.THREADS, redirect: {to: ROUTES.THREADS}},
  {matcher: ROUTES.PARTNERSHIPS, redirect: {to: ROUTES.PARTNERSHIPS}},
  {matcher: ROUTES.CONTENT__LIBRARY, redirect: {to: ROUTES.CONTENT__LIBRARY}},
  {
    matcher: ROUTES.STATS,
    redirect: {sendToEmberIframe: 'stats:brandChanged'},
  },
];

function withoutTrailingSlash(pathname: string): string {
  return pathname.length > 1 && pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname;
}

export function pathMatchesRoutePrefix(
  pathname: string,
  matcher: string
): boolean {
  const path = withoutTrailingSlash(pathname);
  return path === matcher || path.startsWith(`${matcher}/`);
}

export default function resolveBrandChangeRedirect(
  pathname: string
): BrandChangeRedirect | undefined {
  return BRAND_CHANGE_REDIRECTIONS.find(({matcher}) =>
    pathMatchesRoutePrefix(pathname, matcher)
  )?.redirect;
}
